// NEXUS auth context
import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";
import { toast } from "sonner";
import { registerPushNotifications } from "./push";

const AuthCtx = createContext({ user: null, login: () => {}, logout: () => {}, signup: () => {}, refresh: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("nexus_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      registerPushNotifications();
    } catch { setUser(null); localStorage.removeItem("nexus_token"); }
    setLoading(false);
  };
  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nexus_token", data.token);
    setUser(data.user);
    registerPushNotifications();
    toast.success(`Signed in as ${data.user.display_name}`);
    return data.user;
  };
  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("nexus_token", data.token);
    setUser(data.user);
    registerPushNotifications();
    toast.success(`Signed in as ${data.user.display_name}`);
    return data.user;
  };
  // Explicit confirmation on sign-out -- there was previously no feedback at
  // all that logging out had actually happened.
  const logout = () => { localStorage.removeItem("nexus_token"); setUser(null); toast.success("You are signed out"); };

  return <AuthCtx.Provider value={{ user, login, logout, signup, refresh, loading }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
